module.exports = __webpack_public_path__ + "media/images/design/common/images/btn_ing-1f2787ec1c95d5aacba07e83b8d7272a.jpg";